import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from '../mainViewMixin';
import { mapState } from 'vuex';
import { themesMixin, vuetifyColors } from '../../../utils/themes';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'ViewNiotaClassicGatewayManagementGWManagement',
  mixins: [mainViewMixin, themesMixin],
  data: function data() {
    return {
      accountId: undefined,
      filteredList: [],
      filterAlert: false,
      filterWarning: false,
      gatewayCsvImportDialog: false,
      originatorDialog: false,
      visualizationDialog: false,
      hasNonEmptyList: false,
      timeIntDialog: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    headerBG: function headerBG() {
      return './img/gwmgmt.png';
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  methods: {
    getColor: function getColor(type) {
      return vuetifyColors[type] || this.vuetifyColorHex('info');
    },
    updateList: function updateList() {
      this.$refs.list.fetchList();
    },
    addDevice: function addDevice() {
      this.editedItem = {};
      this.originatorDialog = true;
    },
    selectedOriginator: function () {
      var _selectedOriginator = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(originator) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!get(this.editedItem, 'properties')) {
                  set(this.editedItem, 'properties', {});
                }

                this.editedItem.properties.originator = {
                  id: originator.id
                };
                this.editedItem.properties.datasource = {
                  id: get(originator, 'datasource.id')
                };
                this.originatorDialog = false;
                this.formDialog = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function selectedOriginator(_x) {
        return _selectedOriginator.apply(this, arguments);
      }

      return selectedOriginator;
    }(),
    loadedInitialConfig: function loadedInitialConfig(e) {
      var _this = this;

      this.accountId = e.accountId;
      this.filterWarning = e.filterWarning;
      this.filterAlert = e.filterAlert;
      this.$nextTick(function () {
        _this.$refs['list'].fetchList();
      });
    },
    resetFilter: function resetFilter() {
      this.accountId = undefined;
      this.filterWarning = false;
      this.filterAlert = false;
      this.updateList();
    },
    editDevice: function editDevice(item) {
      this.editedItem = item;
      this.formDialog = true;
    },
    pushMapToRouter: function pushMapToRouter() {
      var accountId = this.accountId || this.$store.state.authentication.tenantId;
      this.$router.push("/niota-classic/gw-mgmt/map/".concat(accountId, "/gateways/?warning=").concat(this.filterWarning, "&alert=").concat(this.filterAlert));
    },
    closeVisualization: function closeVisualization() {
      this.visualizationDialog = false;
    },
    closeTimeIntervalModal: function closeTimeIntervalModal() {
      this.timeIntDialog = false;
    }
  }
};